import type { DynamicThemeType } from '../../style/themes';

export const getCurrentTheme = (): DynamicThemeType => {
  const sessionTheme =
    (process.env.ACTUAL_ENV !== 'production' ? sessionStorage.getItem('theme') : undefined) ??
    (process.env.USE_GREEN === 'true' ? 'green' : 'default');
  return sessionTheme === 'green' ? 'green' : 'default';
};
